import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Image as ImageIcon } from "lucide-react";
import { PublicShell } from "../../components/Layouts";
import { api, readUser, imgSrc } from "../../lib/api";

export default function Packages() {
  const [packages, setPackages] = useState([]);
  const [user, setUser] = useState(readUser());

  useEffect(() => {
    api.get("/packages").then((r) => setPackages(r.data)).catch(() => {});
    api.get("/auth/me")
      .then((r) => { setUser(r.data); localStorage.setItem("ha_user", JSON.stringify(r.data)); })
      .catch(() => { localStorage.removeItem("ha_user"); setUser(null); });
  }, []);

  function activateHref(pkg) {
    const target = `/dashboard/deposits?package=${pkg.id}`;
    if (user?.role === "member") return target;
    if (user?.role === "admin") return "/admin";
    return `/register?next=${encodeURIComponent(target)}`;
  }

  return (
    <PublicShell>
      <main className="page">
        <div className="page-intro">
          <div className="eyebrow">PARTICIPATION TIERS</div>
          <h1>Choose how you<br /><em>help forward.</em></h1>
          <p>Each tier is a transparent, time-boxed commitment. Pick the pace that fits your life — the daily production and the four referral levels do the rest.</p>
        </div>
        <div className="packages-grid">
          {packages.map((p, i) => (
            <article className={`package-card ${i === 1 ? "featured" : ""}`} key={p.id} data-testid={`package-card-${i}`}>
              {p.image_url ? (
                <div className="package-image" style={{ backgroundImage: `url(${imgSrc(p.image_url)})` }} />
              ) : (
                <div className="package-image package-image-empty"><ImageIcon size={28} /></div>
              )}
              <div className="package-number">0{i + 1}</div>
              <h3>{p.name}</h3>
              <p>{p.description}</p>
              <div className="price">${Number(p.price).toLocaleString()}<small> / package</small></div>
              <div className="package-stats">
                <span><b>{p.days}</b> days</span>
                <span><b>${p.daily_production}</b> daily</span>
                <span><b>${p.end_of_term}</b> end of term</span>
              </div>
              <Link data-testid={`activate-package-${i}`} to={activateHref(p)} className="btn btn-dark">
                {user?.role === "member" ? "Activate package" : "Get started"} <ArrowRight size={15} />
              </Link>
            </article>
          ))}
          {!packages.length && <div className="empty-activity"><p>Packages will appear here shortly.</p></div>}
        </div>
      </main>
    </PublicShell>
  );
}
